// This function accepts a key, which is looked-up
// in the datalayer and returns the value

function getDataLayerVal(keyVal) {
  for (var i = 0; i < window.dataLayer.length; i++) {
    if (dataLayer[i][keyVal] !== undefined) {
      return dataLayer[i][keyVal];
    }
  }
}

export { getDataLayerVal };



// WEBPACK FOOTER //
// ./Javascript/utils/datalayerextraction.js